// ActionRequired.tsx
import { FC, Fragment,memo, useEffect, useState } from "react";
import ActionRequiredTableHeader from "src/components/actionDashboard/actionRequiredTableHeader";
import ActionRequiredTableRow from "src/components/actionDashboard/actionRequiredTableRow";
import PaginationNav from "src/components/actionDashboard/paginationNav";
import { ActionRequiredTypeProps, TodoDataProps } from "./types";
import NoDataFound from "src/components/noDataFoundComponent";
import { QueryParamsState } from "src/components/manufacturer/caseListing";


const ActionRequired: FC<ActionRequiredTypeProps> = ({ tableData, currentPage, onPageChange, refreshListing }) => {
const [queryParam, setQueryParam] = useState<QueryParamsState>({
       direction: "desc",
       sort_by: "bi_case_id",
     });
   
     const [sortedData, setSortedData] = useState<TodoDataProps[]>([]);
   
     // Initialize sortedData whenever new data comes from props
     useEffect(() => {
       if (tableData?.todos_data) {
         setSortedData([...tableData.todos_data]);
       }
     }, [tableData]);
   
     const changeIdOrder = (tableHeader: string) => {
       const newParams: QueryParamsState = {
         sort_by: tableHeader,
         direction:
           tableHeader === queryParam.sort_by
             ? queryParam.direction === "desc"
               ? "asc"
               : "desc"
             : "desc",
       };
   
       let sorted = [...(tableData?.todos_data || [])];
   
       switch (newParams.sort_by) {
         case "bi_case_id":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? Number(a.bi_case_id) - Number(b.bi_case_id)
               : Number(b.bi_case_id) - Number(a.bi_case_id)
           );
           break;
   
         case "patient_initials_dob":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.patient_initials_dob || "").localeCompare(b.patient_initials_dob || "")
               : (b.patient_initials_dob || "").localeCompare(a.patient_initials_dob || "")
           );
           break;
   
         case "drug_name":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.drug_name || "").localeCompare(b.drug_name || "")
               : (b.drug_name || "").localeCompare(a.drug_name || "")
           );
           break;
   
         case "patient_name":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.patient_name || "").localeCompare(b.patient_name || "")
               : (b.patient_name || "").localeCompare(a.patient_name || "")
           );
           break;
   
         case "bi_completed":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.bi_completed || "").localeCompare(b.bi_completed || "")
               : (b.bi_completed || "").localeCompare(a.bi_completed || "")
           );
           break;
   
         case "clinical_received":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.clinical_received || "").localeCompare(b.clinical_received || "")
               : (b.clinical_received || "").localeCompare(a.clinical_received || "")
           );
           break;

         case "lomn_received":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.lomn_received || "").localeCompare(b.lomn_received || "")
               : (b.lomn_received || "").localeCompare(a.lomn_received || "")
           );
           break;

         case "review_type":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.review_type || "").localeCompare(b.review_type || "")
               : (b.review_type || "").localeCompare(a.review_type || "")
           );
           break;

         case "released":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.released || "").localeCompare(b.released || "")
               : (b.released || "").localeCompare(a.released || "")
           );
           break;

         case "insurance_type":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.insurance_type || "").localeCompare(b.insurance_type || "")
               : (b.insurance_type || "").localeCompare(a.insurance_type || "")
           );
           break;
   
         case "physician":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.physician || "").localeCompare(b.physician || "")
               : (b.physician || "").localeCompare(a.physician || "")
           );
           break;
   
         case "medical_coverage_status":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.medical_coverage_status || "").localeCompare(b.medical_coverage_status || "")
               : (b.medical_coverage_status || "").localeCompare(a.medical_coverage_status || "")
           );
           break;
   
         case "pharmacy_coverage_status":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.pharmacy_coverage_status || "").localeCompare(b.pharmacy_coverage_status || "")
               : (b.pharmacy_coverage_status || "").localeCompare(a.pharmacy_coverage_status || "")
           );
           break;
           case "received_at":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.received_at || "").localeCompare(b.received_at || "")
               : (b.received_at || "").localeCompare(a.received_at || "")
           );
           break;
            case "pa_required":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.pa_required || "").localeCompare(b.pa_required || "")
               : (b.pa_required || "").localeCompare(a.pa_required || "")
           );
           break;
   
         case "qty":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? Number(a.qty ?? 0) - Number(b.qty ?? 0)
               : Number(b.qty ?? 0) - Number(a.qty ?? 0)
           );
           break;

         case "refills":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? Number(a.refills ?? 0) - Number(b.refills ?? 0)
               : Number(b.refills ?? 0) - Number(a.refills ?? 0)
           );
           break;

         case "missing_info":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? Number(a.missing_info ?? 0) - Number(b.missing_info ?? 0)
               : Number(b.missing_info ?? 0) - Number(a.missing_info ?? 0)
           );
           break;

         default:
           break;
       }
   
       setSortedData(sorted);
       setQueryParam(newParams);
     };

  return (
    <Fragment>
      <div className="table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl flex-fill">
        <table className="table table-striped table-sm m-0" style={{minHeight:'300px'}}>
          <ActionRequiredTableHeader queryParam={queryParam}
            changeIdOrder={changeIdOrder}/>
          <tbody className="position-relative">
            {sortedData && sortedData.length>0 ? sortedData.map((item: TodoDataProps, index: number) => (
              <ActionRequiredTableRow
                data={item}
                refreshListing={refreshListing}
                index={index}
              />
            )):<NoDataFound/>
            }
          </tbody>
        </table>
      </div>
      {tableData?.page_count > 1 && (
        <PaginationNav currentPage={currentPage} pageCount={tableData.page_count} onPageChange={onPageChange} />
      )}
    </Fragment>
  );
};

export default memo(ActionRequired);
